import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, APP_PREFIX_PATH } from "configs/AppConfig";
import { useContext, useEffect, useState } from "react";
import { Spin } from "antd";
import useWindowWidth from "helpers/useWindowWidth";
import { NavigationContext } from "App";
import SEO from "components/SEO/SEO";
import WelcomingBanner from "components/page-content/home-content/WelcomingBanner";
import { lazy } from "react";

// Lazy imports for home widgets
const Categories = lazy(() => import("components/page-content/home-content/Categories/Categories"));
const BannerPage = lazy(() => import("components/page-content/home-content/BannerPage/BannerPage"));
const PackageDeals = lazy(() => import("components/page-content/home-content/PackageDeals/PackageDeals"));
const Events = lazy(() => import("components/page-content/home-content/Events/Events"));
const VenuesSlider = lazy(() => import("components/page-content/home-content/VenuesSlider/VenuesSlider"));
const FeaturedSlider = lazy(() => import("components/page-content/home-content/FeaturedSlider/FeaturedSlider"));
const PhotographersSlider = lazy(() => import("components/page-content/home-content/PhotographersSlider/PhotographersSlider"));
const MakeUpSlider = lazy(() => import("components/page-content/home-content/MakeUpSlider/MakeUpSlider"));
const DecoratorsSlider = lazy(() => import("components/page-content/home-content/DecoratorsSlider/DecoratorsSlider"));
const PlanWithEventoq = lazy(() => import("components/page-content/home-content/plan-with-eventoq/PlanWithEventoq"));


const Home = () => {
  // const { user, isLoggedIn } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const { latitude, longitude } = useSelector((state) => state.filter);
  const [venueData, setVenueData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [widgetData, setWidgetData] = useState();
  const [widgetLoading, setWidgetLoading] = useState(true);
  const width = useWindowWidth();
  const [flag, setFlag] = useState(false);
  const { isBackNavigation, setIsBackNavigation } = useContext(NavigationContext);

  const { widgets } = useSelector((state) => state.widgets);
  console.log("widgets in home", widgetData);
  console.log("widget loading", widgetLoading);

  // useEffect(() => {
  //   if (widgets) {

  //     setWidgetData([...widgets].sort((a, b) => a.priority - b.priority)?.reverse());
  //     setWidgetLoading(false);

  //   }
  // }, [widgets]);

  useEffect(() => {
    if (widgets) {
      setWidgetData(widgets);
    }
  }, [widgets]);

  useEffect(() => {
    if (widgetData?.length > 0) {
      setWidgetLoading(false);
    }
  }, [widgetData]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (widgetData?.length == 0) {
  //       setWidgetLoading(false);
  //     }
  //   }, 2500);
  // }, [widgetData]);

  //Used to show login modal if not already logged in
  // useEffect(() => {
  //   if (isLoggedIn) {
  //     navigate(`${APP_PREFIX_PATH}/dashboard`);
  //   } else {
  //     dispatch(
  //       modalActions.changeModalComponent({
  //         modalType: "signin",
  //       })
  //     );
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchVenues();
  // }, [user, latitude]);

  console.log("error value is", error, venueData);

  useEffect(() => {
    if (widgetData?.length > 0 && isBackNavigation) {
      const origin = sessionStorage.getItem("scrollOrigin");
      const targetY = sessionStorage.getItem("scrollTargetY");

      if (origin !== "home" || !targetY) return;

      const scrollY = parseInt(targetY, 10);
      if (isNaN(scrollY)) return;

      const maxAttempts = 10;
      let attempts = 0;

      const tryScroll = () => {
        window.scrollTo({
          top: scrollY,
          behavior: "smooth", // Use 'smooth' if desired
        });

        const currentY = Math.round(window.scrollY);
        const isInPosition = Math.abs(currentY - scrollY) < 5;

        if (!isInPosition && attempts < maxAttempts) {
          attempts++;
          setTimeout(tryScroll, 100);
        }
      };

      tryScroll();

      // Optional: clear the session storage after use
      sessionStorage.removeItem("scrollTargetY");
      sessionStorage.removeItem("scrollOrigin");
    }
  }, [widgetData]);

  return (
    <>
      <SEO />
      {/* <PlanWithEventoq /> */}
      {widgetLoading && !widgetData?.length ? ( // Check the widgetLoading state here
        <Spin
          spinning={widgetLoading}
          size="large"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
            marginBottom: "40px",
          }}
        />
      ) : (
        ""
      )}
      {!widgetLoading && widgetData && widgetData.length === 0
        ? // <h4 className="home-error">No Data Found</h4>
          ""
        : widgetData?.map((item) => {
            // Determine if the component should be shown based on device type
            const shouldShowOnDesktop = item?.deviceType?.includes("Desktop");
            const shouldShowOnMobile = item?.deviceType?.includes("Mobile");

            // Render based on the device type and the current device
            if (shouldShowOnDesktop && width > 600) {
              if (item.type === "Banner") {
                return <WelcomingBanner data={item} />;
              }
              // else if (item.type === "Page" && item?.categoryName == "Blogs") {
              //   return <BlogsList data={item} />;
              // }
              else if (item.type === "Category") {
                return <Categories data={item} />;
              } else if (item.type === "Listing" && !item?.categoryName) {
                return <VenuesSlider user={user} data={item} />;
              } else if (item.type === "Listing" && item?.categoryName) {
                return <PhotographersSlider user={user} data={item} />;
              } else if (item.type === "Event") {
                return <Events data={item} />;
              } else if (item.type === "Offers") {
                return <BannerPage data={item} />;
              } else if (
                item.type == "Page" &&
                item?.pagesCategorySlug == "event-planning"
              ) {
                return <PlanWithEventoq data={item} />;
              } else if (item.type === "Static") {
                return (
                  <div
                    className="home-static"
                    dangerouslySetInnerHTML={{ __html: item?.staticContent }}
                  ></div>
                );
              } else {
                // return <div key={item._id}>Unknown Type</div>;
              }
            } else if (shouldShowOnMobile && width <= 768) {
              // Similar conditional rendering for mobile
              if (item.type === "Banner") {
                return <WelcomingBanner data={item} />;
              }
              // else if (item.type === "Page" && item?.categoryName == "Blogs") {
              //   return <BlogsList data={item} />;
              // }
              else if (item.type === "Category") {
                return <Categories data={item} />;
              } else if (item.type === "Listing" && !item?.categoryName) {
                return <VenuesSlider data={item} />;
              } else if (item.type === "Listing" && item?.categoryName) {
                return <VenuesSlider user={user} data={item} />;
              } else if (item.type === "Listing" && !item?.categoryName) {
                return <PhotographersSlider user={user} data={item} />;
              } else if (item.type === "Event") {
                return <Events data={item} />;
              } else if (item.type === "Offers") {
                return <BannerPage data={item} />;
              } else if (
                item.type == "Page" &&
                item?.pagesCategorySlug == "event-planning"
              ) {
                return <PlanWithEventoq data={item} />;
              } else if (item.type === "Static") {
                return (
                  <div
                    className="home-static"
                    dangerouslySetInnerHTML={{ __html: item?.staticContent }}
                  ></div>
                );
              } else {
                // return <div key={item._id}>Unknown Type</div>;
              }
            } else {
              return null; // Do not render anything if the device type does not match
            }
          })}
      {/* <WelcomingBanner
        categoryData={categoryData}
        eventData={eventData}
        vendorList={vendorList}
      /> */}
      {/* <Categories categoryData={categoryValues} /> */}
      {/* <PackageDeals /> */}

      {/* {venueData?.length != 0 && ( */}
      <>
        {" "}
        {/* Wrap all your sections in a fragment */}
        {/* <VenuesSlider user={user} venueData={venueData} /> */}
        {/* <BannerPage /> */}
        {/* <FeaturedSlider user = {user} venueData = {venueData} /> */}
        {/* <PhotographersSlider user={user} venueData={venueData} /> */}
        {/* <Events eventData={eventData} /> */}
        {/* <MakeUpSlider user={user} venueData={venueData} /> */}
        {/* <BannerPage /> */}
        {/* <DecoratorsSlider user={user} venueData={venueData} /> */}
      </>
      {/* )} */}
    </>
  );
};

export default Home;
